import { Theme } from '@shoutem/theme';
import getThemeStyle from './theme';

function setDefaultThemeStyle() {
  const theme = getThemeStyle();
  Theme.setDefaultThemeStyle(theme);
}

export {
  setDefaultThemeStyle,
};



// WEBPACK FOOTER //
// ./node_modules/@shoutem/ui/init.js